import React from 'react';
import CourseCommunityHeader from './CourseCommunityHeader';
import CourseTitleHeader from './CourseTitleHeader';

export default function CourseMultiHeader() {
  return (
    <>
      <CourseCommunityHeader />
      <CourseTitleHeader />
    </>
  );
}
